import { z } from 'zod';
export const tenantConnectionPageSchema = z.object({ connections: z.array(z.object({
        id: z.string().uuid(), provider: z.enum(['supabase', 'netlify', 'railway', 'mailgun', 'cloudflare']),
        accountId: z.string().min(1).max(200), version: z.number().int().positive().safe(),
        status: z.enum(['connected', 'expired', 'revoked']), expiresAt: z.string().datetime(), revocable: z.boolean(),
        resources: z.array(z.object({ id: z.string().min(1).max(200), environment: z.enum(['preview', 'production']) }).strict()).min(1).max(100),
    }).strict()).max(20), nextAfter: z.string().uuid().nullable() }).strict();
//# sourceMappingURL=tenant-connections.js.map